import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fullName: "",
  phone: "",
  email: "",
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    updateCustomerDetail: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateCustomerDetail } = customerSlice.actions;
export default customerSlice.reducer;
